import { MapTo } from '@adobe/aem-react-editable-components';
import AboutUsCard, { AboutUsCardEditConfig } from './AboutUsCard';

export default MapTo('cob-corp-acquisition/components/creditonebank/about-us-card')(AboutUsCard, AboutUsCardEditConfig);